
<footer class="main-footer text-center"><span class="font-weight-bold">&copy; {{year}}, iTalent Corporation. All Rights Reserved.</span>
</footer>
